<template>
	<v-card light class="mx-auto mb-2" outlined>
		<template v-if="mode === 'full'">
			<v-list-item three-line>
				<v-list-item-content>
					<div class="overline mb-2">SUB BRAND</div>
					<v-list-item-title class="headline mb-1">
						{{ item.title }}
					</v-list-item-title>
					<p class="lh-1">{{ item.what }}</p>
				</v-list-item-content>

				<v-list-item-avatar tile size="120" color="grey">
					<v-img :src="item.src"></v-img>
				</v-list-item-avatar>
			</v-list-item>

			<v-row>
				<v-col cols="6" sm="3">
					<v-list-item two-line>
						<v-list-item-content>
							<v-list-item-title>Audience</v-list-item-title>
							<v-list-item-subtitle>{{ item.audience }}</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>
				</v-col>
				<v-col cols="6" sm="3">
					<v-list-item two-line>
						<v-list-item-content>
							<v-list-item-title>Communications</v-list-item-title>

							<v-list-item-subtitle
								v-for="(sub, i) in item.communications"
								:key="`${sub}-${i}`"
							>
								<p class="green--text body-1">
									<v-icon>mdi-blur-radial</v-icon>
									{{ sub }}
								</p>
							</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>
				</v-col>
				<v-col cols="6" sm="3">
					<v-list-item two-line>
						<v-list-item-content>
							<v-list-item-title>Etisalat Logo</v-list-item-title>
							<v-list-item-subtitle>{{ useLogo }}</v-list-item-subtitle>
							<p class="mt-1" v-if="item.logo_why">{{ item.logo_why }}</p>
						</v-list-item-content>
					</v-list-item>

					<v-list-item two-line>
						<v-list-item-content>
							<v-list-item-title>Etisalat Look & Feel</v-list-item-title>
							<v-list-item-subtitle>{{ useLook }}</v-list-item-subtitle>
							<p class="mt-1" v-if="item.look_why">{{ item.look_why }}</p>
						</v-list-item-content>
					</v-list-item>
				</v-col>
				<v-col cols="3"> </v-col>
			</v-row>
		</template>

		<template v-if="mode === 'thumbnail'">
			<v-list-item three-line>
				<v-list-item-content>
					<div class="overline mb-2">
						SUB BRAND
					</div>
					<v-list-item-title class="headline mb-1">
						{{ item.title }}
					</v-list-item-title>
					<p>{{ item.what }}</p>
					<div class="block mt-5 mb-5">
						<v-chip class="black--text" :color="cluserColor(item.cluster)">{{
							item.cluster
						}}</v-chip>
					</div>
				</v-list-item-content>

				<v-list-item-avatar tile size="120" color="grey" v-if="item.src">
					<v-img :src="item.src"></v-img>
				</v-list-item-avatar>
			</v-list-item>
		</template>

		<template v-if="mode === 'compact'">
			<h3 class="pa-3">
				{{ item.title }}
				<!-- <v-chip
					class="ml-3 black--text"
					v-if="item.cluster !== 'N/A'"
					:color="cluserColor(item.cluster)"
					>{{ item.cluster }}</v-chip
				> -->
			</h3>
			<!-- <v-list-item-avatar tile size="120" color="grey" v-if="item.src">
          <v-img :src="item.src"></v-img>
        </v-list-item-avatar> -->
		</template>

		<v-card-actions
			v-if="controls"
			class="d-flex justify-space-between flex-row"
		>
			<v-btn class="" small outlined text @click="show(index)">
				Show
			</v-btn>
			<div>
				<v-btn class="ml-2" small outlined rounded text @click="edit(index)">
					Edit
				</v-btn>
				<v-btn class="ml-2" small outlined rounded text @click="remove(index)">
					Delete
				</v-btn>
			</div>
		</v-card-actions>
	</v-card>
</template>

<script>
// @ is an alias to /src

export default {
	name: 'ArchitectureCard',
	data() {
		return {
			expanded: false,
		};
	},
	props: {
		item: {
			type: Object,
			default: () => ({}),
		},
		index: {
			type: Number,
			default: 0,
		},
		thumbnail: {
			type: Boolean,
			default: false,
		},
		controls: {
			type: Boolean,
			default: true,
		},
		mode: {
			type: String,
			default: 'full',
		},
	},
	methods: {
		edit(index) {
			this.$emit('edit', index);
		},
		remove(index) {
			this.$emit('remove', index);
		},
		show(index) {
			this.$emit('show', index);
		},
		toggleExpand() {
			this.expanded = !this.expanded;
		},
		cluserColor(title) {
			const item = this.$t(`${this.$route.meta.content}.dropdown`).find(
				(x) => x.title === title
			);
			return item ? item.color : '';
		},
	},
	computed: {
		useLogo() {
			return this.item.logo ? 'Yes' : 'No';
		},
		useLook() {
			return this.item.look ? 'Yes' : 'No';
		},
	},
};
</script>

<style lang="scss" scoped>
.lh-1 {
	line-height: 1.6;
}
</style>
